document.addEventListener('DOMContentLoaded', function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-ub-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-ub-track]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-ub-slide]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-ub-dot]'));
    var intervalSeconds = parseFloat(carousel.getAttribute('data-interval')) || 4.5;
    var index = 0;
    var timer = null;

    if (slides.length <= 1) return;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (dot, di) {
        var active = di === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function next() {
      goTo(index + 1);
    }

    function start() {
      if (reducedMotion) return; // don't auto-advance for reduced-motion users
      stop();
      timer = setInterval(next, intervalSeconds * 1000);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
        start(); // restart the timer so a manual pick doesn't get cut short
      });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);

    goTo(0);
    start();
  });
});
